module.exports = __webpack_public_path__ + "static/media/image-11.8a1ae01f.jpg";